import React from 'react';
import { IconCategory } from '@tabler/icons';
import SimpleLookupCrud from '../references/SimpleLookupCrud';

const ServiceCategories = () => (
    <SimpleLookupCrud
        icon={IconCategory}
        gradient="teal"
        title="Categorias de Serviço"
        subtitle="Organize seu catálogo de serviços em categorias (pode ter subcategorias)"
        endpoint="service-categories"
        addLabel="Nova categoria"
        columns={[
            { key: 'name', label: 'Nome', type: 'text', required: true },
            { key: 'parent', label: 'Categoria pai', type: 'select', optionsSource: 'self' }
        ]}
    />
);

export default ServiceCategories;
